import React, { useState } from 'react';
import '../../styles/About.css'
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';

export default function Board() {
    const [ chairmen, setChairmen ] = useState([
        {
        id: 1,
        name: "Delreo Newman",
        role: "Chairman",
        subrole: "Executive Director of International Regulatory and Government Affairs, ATNI",
        image: "https://www.canto.org/wp-content/uploads/2018/02/IMG_5118_ppnew-e1518812677553.jpg",
        link: 'https://www.linkedin.com/in/dr-delreo-newman-28473a1/',
        },
        {
        id: 2,
        name: "Charles Douglas",
        role: "Vice Chairman",
        subrole: "Director of Regulatory Affairs, CWC, Grenada",
        image: process.env.PUBLIC_URL + '/assets/Douglas.png',
        link: 'https://www.linkedin.com/in/charles-a-douglas-998889220/',
        },
    ])

    const [boardMembers, setBoardMembers] = useState([
        {
        id: 3,
        name: "Teresa Wankin",
        role: "Secretary General",
        subrole: "",
        image: "https://www.canto.org/wp-content/uploads/2020/03/TERESA-WEBSITE-e1674743684270.jpg",
        link: 'https://www.linkedin.com/in/teresa-wankin-59a2b155/ ',
        },
        {
        id: 4,
        name: "Gerard Cooper",
        role: "Treasurer",
        subrole: "Chief Financial Officer (Ag.), TSTT",
        image: process.env.PUBLIC_URL + '/assets/Cooper.png',
        link: 'https://www.linkedin.com/in/gerard-cooper-b17b4332/',
        },
        {
        id: 6,
        name: "Desha Clifford",
        role: "Director",
        subrole: "Deputy General Counsel - Regulatory Affairs, Digicel Turks & Caicos",
        image: "https://www.canto.org/wp-content/uploads/2020/05/1524023239100.jpg",
        link: 'https://www.linkedin.com/in/deshaclifford/',
        },
        {
        id: 7,
        name: "Mark Reynolds",
        role: "Director",
        subrole: "General Counsel, Logic",
        image: process.env.PUBLIC_URL + '/assets/Mark.png',
        link: 'https://www.linkedin.com/in/mark-reynolds-8b2a2156/',
        },
        {
        id: 8,
        name: "Dickson Osuala",
        role: "Director",
        subrole: "Group Head of Regulatory Affairs, Digicel Trinidad and Tobago",
        image: process.env.PUBLIC_URL + '/assets/Dickson.png',
        link: 'https://www.linkedin.com/in/dickson-c-t-osuala-phd-68785331/',
        },
        {
        id: 9,
        name: "Rhys Campbell",
        role: "Director",
        subrole: "Head of CWC Foundation and ESG, Cable & Wireless Communications",
        image: process.env.PUBLIC_URL + '/assets/Rhys.png',
        link: 'https://www.linkedin.com/in/rhys-d-campbell-3836b883/',
        },
        {
        id: 10,
        name: "Vaughn Brown",
        role: "Director",
        subrole: "Telecoms Business Unit Manager, Antigua Public Utilities Authority",
        image: process.env.PUBLIC_URL + '/assets/Vaughn.png',
        link: '',
        },
        {
        id: 11,
        name: "John Gomez",
        role: "Director",
        subrole: "CEO, Be ALIV Bahamas",
        image: process.env.PUBLIC_URL + '/assets/Gomez.png',
        link: 'https://www.linkedin.com/in/john-gomez-83b6b37b/',
        },
    ]);

    function renderBoardMembers(){

        const render_board_members = boardMembers.map((member, index) => 
            <Link to={member.link} target='_blank' className='board-member-new' onClick={() => {

            }}>
                <div className='board-member-photo' style={{backgroundImage: `url(${member.image})`,
                    backgroundSize: 'cover',}}
                ></div>
                
                <div className='board-member-content'>
                    <div>
                        <div className='board-member-title'>{member.name} <FaLinkedin size={18} color='#0072b1' style={{marginLeft: '8px'}}/></div>
                        <div className='board-member-subtitle'>{member.role}</div>
                    </div>
                    
                    <div className='board-member-subrole'>{member.subrole}</div>
                </div>
            </Link>
        )

        return render_board_members;

   }

   const renderHeads = () => {
        const render_heads = chairmen.map((member, index) => 
            <Link to={member.link} target='_blank' className='board-member-new' onClick={() => {

            }}>
                <div className='board-member-photo' style={{backgroundImage: `url(${member.image})`,
                    backgroundSize: 'cover',}}
                ></div>
                
                <div className='board-member-content'>
                    <div>
                        <div className='board-member-title'>{member.name} <FaLinkedin size={18} color='#0072b1' style={{marginLeft: '8px'}}/></div>
                        <div className='board-member-subtitle'>{member.role}</div>
                    </div>
                    
                    <div className='board-member-subrole'>{member.subrole}</div>
                </div>
            </Link>
        )

        return render_heads;
   }

  return (
    <div style={{paddingTop: '100px'}}>
        <div className='board-header'>
            Meet our Board of Directors
        </div>
        <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent:'center', background: '#282C68', paddingTop: '50px'}}>
            {renderHeads()}
        </div>
        <div className='about-board-members-container-new' style={{flexWrap: 'wrap'}}>
            {renderBoardMembers()}
        </div>
    </div>
  )
}
